import { UserGroup } from 'module/api/user-group/types';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { UserGroupAPI } from 'api/user-group';

export const useGetAllUserGroupsQuery = (
  options?: Omit<
    UseQueryOptions<UserGroup[], Error, UserGroup[], string[]>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: ['user-groups'],
    queryFn: () => UserGroupAPI.getUserGroups(),
    ...options,
  });
};
